const actions = {
    setTwitData: { type: 'SET_TWIT_DATA'},
    setMessagesData: { type: 'SET_MESSAGES_DATA'},
    setUserCount: { type: 'SET_USER_COUNT'},
    setPeopleData: { type: 'SET_PEOPLE_DATA'},
    setSearchData: { type: 'SET_SEARCH_DATA'},
    setUsersData: { type: 'SET_USERS_DATA'},
    setNewsType: { type: 'SET_NEWS_TYPE'},
    setPage: { type: 'SET_PAGE'},
    setTotalPages: { type: 'SET_TOTAL_PAGES'},
    setSearchQuery: { type: 'SET_SEARCH_QUERY'},
    setNetworkStatus: { type: 'SET_NETWORK_STATUS'},
    setFormActive: { type: 'SET_FORM_ACTIVE'},
    setUser: { type: 'SET_USER'},
    setSubs: { type: 'SET_SUBS'},
    deleteTwit: { type: 'DELETE_TWIT'},
    updateTwit: { type: 'UPDATE_TWIT'},
    setRefreshTwitData: { type: 'SET_REFRESH_TWIT_DATA'}
  }
  
  export default actions;
  